import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check, ChevronDown } from "lucide-react";
import { LANGUAGES } from "@/i18n";

export default function LanguageSwitcher({ variant = "header" }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative" data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        className={`inline-flex items-center gap-2 px-3 py-2 rounded-full text-[13px] font-medium transition-colors duration-200 ${
          variant === "header"
            ? "hover:bg-black/5 mv-green-text border border-transparent hover:border-black/10"
            : "bg-white/10 text-white border border-white/25"
        }`}
        aria-label="Change language"
        data-testid="language-switcher-toggle"
      >
        <Globe size={15} />
        <span className="hidden sm:inline">{current.native}</span>
        <span className="sm:hidden text-[16px]">{current.flag}</span>
        <ChevronDown size={13} className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-56 rounded-2xl overflow-hidden mv-card z-50"
          style={{ background: "#fff" }}
          data-testid="language-switcher-menu"
        >
          <div className="px-4 py-2 text-[10px] uppercase tracking-[0.24em] border-b mv-hairline" style={{ color: "var(--mv-muted)" }}>
            Language · Ulimi · Puo
          </div>
          <ul>
            {LANGUAGES.map((l) => {
              const active = l.code === current.code;
              return (
                <li key={l.code}>
                  <button
                    onClick={() => change(l.code)}
                    className={`w-full flex items-center gap-3 px-4 py-2.5 text-[13.5px] text-left hover:bg-[var(--mv-bg)] transition-colors duration-150 ${
                      active ? "mv-green-text font-semibold" : ""
                    }`}
                    data-testid={`lang-${l.code}`}
                  >
                    <span className="text-[16px]">{l.flag}</span>
                    <span className="flex-1">{l.native}</span>
                    {active && <Check size={14} style={{ color: "var(--mv-gold)" }} />}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
